import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  type ChargesFilter,
  type UseQueryReturnType,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { feeKeys } from './keys';

const serviceCharge = graphql(/* GraphQL */ `
  query fees_serviceCharges($filter: ChargesFilter) {
    fees_serviceCharges(filter: $filter) {
      amount
      userServiceCharge
      userVat
    }
  }
`);

const serviceChargeQuery = (filter: ChargesFilter) => ({
  queryKey: feeKeys.serviceCharge(filter),
  queryFn: () => gqlClient.request(serviceCharge, { filter }),
});

export function getServiceCharge(filter: ChargesFilter) {
  return queryClient.fetchQuery(serviceChargeQuery(filter));
}

export function useServiceCharge(filter: ChargesFilter) {
  return useQuery({
    ...serviceChargeQuery(filter),
    placeholderData: keepPreviousData,
    select: ({ fees_serviceCharges }) => fees_serviceCharges,
  });
}

export type ReturnTypeFromUseServiceCharge = UseQueryReturnType<
  typeof useServiceCharge
>;
